import React from 'react';
import { SvgIcon } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as LoadingCircle } from '../assets/icons/loading-circle.svg';
import { getLoadingColor, rotation } from './styles';

interface LoadingRingProps {
    className?: string;
    color?: 'primary' | 'secondary' | 'alt';
}

const LoadingRing: React.FCC<LoadingRingProps> = (props) => {
    const theme = useTheme();
    return (
        <SvgIcon
            className={props.className}
            sx={{
                animation: `${rotation} 2000ms linear infinite`,
                transformOrigin: 'center center',
                color: getLoadingColor(theme, props.color),
            }}
            component={LoadingCircle}
            viewBox="0 0 20 20"
        />
    );
};

export default LoadingRing;
